module.exports = __webpack_public_path__ + "img/sph.74538266.png";